<template lang="pug">
.generic-wrapper
    .container
        BackButton(name="FinancesOverview")
        h1.title Eigentümerabrechnung
        .sub-headline Hier können Sie eine neue Eigentümerabrechnung erstellen.

        //- b-message.margin-top(type='is-danger' has-icon='')
        //-     | Diese Funktionalität befindet sich derzeit im Aufbau und ist als Beta-Funktion in Absprache mit Kerstin Bruns zu testen.

        b-tabs.margin-top(type="is-boxed" destroy-on-hide)

            b-tab-item(label='Eigentümerabrechnung erstellen' icon='account-details')
                OwnerSettlementCreate(:earliestStartDate="earliestStartDate")

            b-tab-item(label='Abrechnungsprotokoll' icon='chart-box-outline')
                OwnerSettlementProtocol()
</template>

<script>
import OwnerSettlementCreate from '@/components/organisms/OwnerSettlementCreate.vue'
import OwnerSettlementProtocol from '@/components/organisms/OwnerSettlementProtocol.vue'

export default {
    components: {
        OwnerSettlementCreate,
        OwnerSettlementProtocol
    },
    data() {
        return {
            owners: [],
        };
    },
    computed: {
        earliestStartDate() {
            const dates = this.owners.map(o => o.createdAt);
            const orderedDates = dates.sort(function (a, b) {
                return Date.parse(a) > Date.parse(b);
            });
            return orderedDates[0] || new Date();
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>

</style>